import { useEffect, useRef } from "react";
import { DatePicker } from "@deere/fuel-react";

export const DatePickerWithHighlights = (props) => {

    const {name, value, onChange, min, highlightedDates, enableTime, placeholder, max} = props;

    const datePickerRef = useRef(null);

    const today = new Date();

    useEffect(() => {
        const inputElement = datePickerRef.current.input;
        inputElement.addEventListener('keydown', (e) => e.preventDefault());
        return () => {
            inputElement.removeEventListener('keydown', (e) => e.preventDefault());
        };
    }, []);
   
    const options = {
        onDayCreate: (dObj, dStr, fp, dayElem) => {
          const dateStr = dayElem.dateObj.setHours(0,0,0,0);
            if (highlightedDates) {
            highlightedDates.forEach((highlight) => {
              const highlightDateString = highlight.setHours(0,0,0,0);
              if (dateStr === highlightDateString) {
              dayElem.style.backgroundColor = "#D2E1CF";
              }
            });
            }
        },
    };
   
    return (
    <div>
      <DatePicker
          id={name}
          ref={datePickerRef}
          value={value}
          onChange={onChange}
          enableTime={enableTime}
          dateFormat= {enableTime==="false"?"M d, Y":"M d, Y, G:i K"}
          // minDate={today}
          maxDate={max}
          placeholder={placeholder}
          flatpickrOptions={options}
        />
    </div>
    );
  };
   